import React from 'react';
import AppBar from '../../../commons/AppBar'
import ButtonsModules from '../../../commons/ButtonsModules';
import SiteMap  from '../../../commons/SiteMap';
import SpecificComponent from '../../../commons/SpecificComponent';
import { Grid } from '@material-ui/core';
import { TopButtons } from '../../../commons/TopButtons';
import AnalizeFurnizori from '../AnalizeFurnizori';
import { Line, Chart } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels'
import Utils from '../../../providers/Utils';
import FisaClientWithChart from '../Components/FisaClientWithChart';
import AnalizeClienti from '../Analize';
import Ws from '../../../providers/Ws';
import BackToTop from '../../../commons/BackToTop';

export default class SoldFurnizor extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
       
        listFise:[],
        dateUniceAll:[],
        facturiAll:[],
        facturiAllFC:[],
        dateUniceAllFC:[],
        
        mapButtons:[{id:'financiarcontabil', label:'Inapoi Financiar', color:'#900DCB'},
        {id:'arf', label:'Analiza si raportare financiara (ARF)', color:'#900DCB'}
    ]
}
    }

     componentDidMount(){
         this.getData()
         Chart.plugins.unregister(ChartDataLabels);
    }

    u = new Utils()

    getDateUnice = (ds) =>{


        let listSorted = ds.sort((a,b)=>{

            let term1 = a.termen.split('.') 
            let term2 = b.termen.split('.')
            
            return new Date(term1[2], term1[1], term1[0]).getTime() - new Date(term2[2], term2[1], term2[0]).getTime()
        })

        let rez = new Set()

        listSorted.forEach(d =>{
        
            rez.add(d['termen'])
        })

        return rez;

    }

    getData = async() =>{

        let ws = new Ws();
        let a = new AnalizeFurnizori()

        let f = new AnalizeClienti()

        let _data =  a.getFacturiNew()
        let _allFacturi =  a.getFacturiAllNew()
        let _allFacturiClienti =  f.getFacturiAllNew()
        let _bileteOrdin =ws.customSelect('select * from fin_bilete_ordin', {
            p1: 'furnizor'
        })

        let [data, allFacturi, allFacturiClienti, bileteOrdin] = await Promise.all([_data,_allFacturi, _allFacturiClienti, _bileteOrdin])

        // console.log('bileteOrdin :', bileteOrdin);

        // console.log('allFacturi :', allFacturi);
        // console.log('data :', data);

        let dataClone = [...data]

        let u = new Utils()
       
                let cloneBilete = bileteOrdin.Content


        for(let i =0 , n= dataClone.length; i< n ; i++){

          

             
                // dataClone[i].facturiInTermen = dataClone[i].facturiInTermen.sort((a,b)=>{

                //     let term1 = a.termen.split('.') 
                //     let term2 = b.termen.split('.')
                    
                //     return new Date(term1[2], term1[1], term1[0]).getTime() - new Date(term2[2], term2[1], term2[0]).getTime()
                // }) 
              
             
            // console.log('dataClone[i].facturiTermenDepasit :', dataClone[i].facturiTermenDepasit);

            let counterFacturi = dataClone[i].facturiTermenDepasit.length
                
                for(let j =0 ; j < counterFacturi; j++){
                    let bilete = cloneBilete.filter(b => b.tip === 'furnizor')

                    let bilet = bilete.filter(b => b.factura === dataClone[i].facturiTermenDepasit[j].document)

                    if(bilet.length > 0){
                     
                            dataClone[i].facturiTermenDepasit[j].document = bilet[0].factura

                            let termen = u.ParseDataFromSql(bilet[0].termen)

                            // console.log('termen :', termen);
                             let termenSpl = termen.split('-')

                             termen = `${termenSpl[2]}.${termenSpl[1]}.${termenSpl[0]}`

                        dataClone[i].facturiTermenDepasit[j].termen = termen
                        dataClone[i].facturiTermenDepasit[j].total = bilet[0].suma
                        dataClone[i].facturiTermenDepasit[j].color = 'red'

                        
                    
                    }else{

                        dataClone[i].facturiTermenDepasit[j].color = this.u.colorFurnizoriClienti.furnizor
                    }
                }
            

            dataClone[i].facturiTermenDepasit = dataClone[i].facturiTermenDepasit.sort((a,b)=>{

                let term1 = a.termen.split('.') 
                let term2 = b.termen.split('.')
                
                return new Date(term1[2], term1[1], term1[0]).getTime() - new Date(term2[2], term2[1], term2[0]).getTime()
            }) 


          

     

            let dateUnice = Array.from(this.getDateUnice(dataClone[i].facturiTermenDepasit))

            // let dateUniceInTermen =Array.from(this.getDateUnice(dataClone[i].facturiInTermen))

            // let counterTermen = dateUniceInTermen.length

            let counterDepasit = dateUnice.length

            // let chartDataTermen= []

            let chartDataDepasit = []

        

            for(let k = 0; k< counterDepasit ; k++){
                let facturi = dataClone[i].facturiTermenDepasit.filter(f => f.termen === dateUnice[k])

               
                
                
       
                chartDataDepasit.push({data:dateUnice[k], facturi:facturi,  })
            }

            // for(let k = 0; k< counterTermen ; k++){
            //     let facturi = dataClone[i].facturiInTermen.filter(f => f.termen === dateUniceInTermen[k])

            //     chartDataTermen.push({data:dateUniceInTermen[k], facturi:facturi })
            // }
            // dataClone[i].chartDataTermen = chartDataTermen
            dataClone[i].chartDataDepasit = chartDataDepasit
        }

    

        let allFacturiFC = []

        let allFacturiPrel = []

        for(let i = 0 , n = allFacturi.length; i < n; i++){
            let bilete = cloneBilete.filter(b => b.tip === 'furnizor')
            let bilet = bilete.filter(b => b.factura === allFacturi[i].document)

            if(bilet.length > 0){
                allFacturi[i].document = bilet[0].factura

                    let termen = u.ParseDataFromSql(bilet[0].termen)

                    // console.log('termen :', termen);
                     let termenSpl = termen.split('-')

                     termen = `${termenSpl[2]}.${termenSpl[1]}.${termenSpl[0]}`

                      allFacturi[i].total = bilet[0].suma
                     allFacturi[i].termen = termen
                     allFacturi[i].color = 'red'
            }else{

                allFacturi[i].color = this.u.colorFurnizoriClienti.furnizor
            }

            allFacturiPrel.push(allFacturi[i]) 
                allFacturiFC.push(allFacturi[i])   
        }

        // console.log('allFacturiPrel :', allFacturiPrel);
        // console.log('allFacturiFC :', allFacturiFC);

      

        for( let i = 0, n = allFacturiClienti.length; i < n; i++){

            let bilete = cloneBilete.filter(b => b.tip === 'client')
            let bilet = bilete.filter(b => b.factura === allFacturiClienti[i].document)

            if(bilet.length > 0){
                allFacturiClienti[i].document = bilet[0].factura

                    let termen = u.ParseDataFromSql(bilet[0].termen)

                    // console.log('termen :', termen);
                     let termenSpl = termen.split('-')

                     termen = `${termenSpl[2]}.${termenSpl[1]}.${termenSpl[0]}`

                     allFacturiClienti[i].total = bilet[0].suma
                     allFacturiClienti[i].termen = termen
                     allFacturiClienti[i].color = 'green'
            }else{

                allFacturiClienti[i].color = this.u.colorFurnizoriClienti.client
            }

            allFacturiFC.push(allFacturiClienti[i])   
        }

        let dateUniceAll = Array.from(this.getDateUnice(allFacturi))

        let dateUniceAllFC = Array.from(this.getDateUnice(allFacturiFC))

        // console.log('dateUniceAll :', dateUniceAll);

        // console.log('allFacturi :', allFacturi);

        this.setState({listFise:dataClone,
                        dateUniceAll:dateUniceAll,
                        facturiAllFC:allFacturiFC,
                        dateUniceAllFC:dateUniceAllFC,
                    facturiAll:allFacturiPrel})

     

    }

    goBack = (id) =>{
        this.props.history.push(`/${id}`)
    }
     render() { 
       return (
          <div>
                <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.financiar} />
                <BackToTop
    
                            />
                          
            
                <ButtonsModules history={this.props.history}
                    scop={'soldFurnizor'} />

        <div style={{textAlign:'left'}}>
            {this.state.mapButtons.map((b,idx)=>{
                return(
                    <SiteMap 
                        key={idx}
                        b={b}
                        buttonSelected={this.goBack} />
                        
                )
            })}
        </div>
        <h1 className='pm-title'>Sold Furnizor</h1>

        {this.state.listFise.length === 0 && 
            <h2 style={{color:'red'}} className='pm-title'>NU EXISTA DATE !</h2>    
    }

        {this.state.listFise.map((f,idx)=>{
            return (
                <Grid  style={{border:'1px dashed gray', 
                                width:'95%', 
                                margin:'auto', 
                                padding:5,
                                marginTop:20}} container key={idx}>
                    <Grid item  xs={12} sm={12} md={6} lg={6} xl={6}>
                        <h3 className='pm-title'>{f.client}</h3>
                        {/* {f.facturiInTermen.length > 0 &&
                        
                                <FisaClientWithChart
                                    termenDepasit={false}
                                    listFacturi={f.facturiInTermen}
                            />
                        } */}

                   
                        {
                            f.facturiTermenDepasit.length > 0 &&
                            <FisaClientWithChart
                                   
                                    listFacturi={f.facturiTermenDepasit}
                            />
                        }
                    
                    </Grid>
                    <Grid item  xs={12} sm={12} md={6} lg={6} xl={6}>
                    {/* {f.facturiInTermen.length > 0 &&
                    <Line
                    
              
                    data ={{
                        labels:[''].concat(f.chartDataTermen.map(r => r.data)).concat(['']),
                        datasets:[
                            {
                                label:f.client,
                                backgroundColor:'transparent',
                                borderColor:'transparent',
                                
                                hoverBackgroundColor:'red',
                                pointBackgroundColor:'red',
                                pointRadius:7,
                                pointHoverRadius:7,
                                hoverBorderColor:'red',
                                data:f.facturiInTermen.map((c)=>{return {x:c.termen, y:c.total}})
                            },
                            
                        ]

                    }}

                    options={{
                        legend:false,
                        
                        scales:{
                            yAxes:[{
                                afterFit:function(e){
                                    e.width=60
                                },
                                stacked:true,
                                
                                //  ticks:{
                                //      callback:(label,index,labels)=>{
                                //          console.log('label :', label);
                                //          console.log('index :', index);
                                //          console.log('labels :', labels);
                                //          return label + ' %'
                                //      },
                                //      min:0,
                                //      max:100
                                //  },
                            }]

                        },
                        tooltips:{
                            callbacks:{
                                
                                label:(v,c)=>{
                                    // console.log('v :', v.index);
                                    // console.log('cccc :', c.datasets)
                                    
                                    return c.datasets[0].label
                                },
                                title:(c)=>{
                                    // console.log('c :', c);
                                    return ''
                                }
                            }
                            
                       }
                        
                        
                    }}
                
                    />
                } */}
                {f.facturiTermenDepasit &&
                    <Line
                    
              
                    data ={{
                        labels:[''].concat(f.chartDataDepasit.map(r => r.data)).concat(['']),
                        datasets:[
                            {
                                label:f.client,
                                backgroundColor:'transparent',
                                borderColor:'transparent',
                                
                                hoverBackgroundColor:f.facturiTermenDepasit.map(r => r.color),
                                pointBackgroundColor:f.facturiTermenDepasit.map(r => r.color),
                                pointRadius:15,
                                pointHoverRadius:15,
                                hoverBorderColor:f.facturiTermenDepasit.map(r => r.color),
                                data:f.facturiTermenDepasit.map((c)=>{return {x:c.termen, y:c.total}})
                            },
                            
                        ]

                    }}

                    options={{
                        legend:false,
                        
                        scales:{
                            yAxes:[{
                                afterFit:function(e){
                                    e.width=60
                                },
                                stacked:true,
                                
                                //  ticks:{
                                //      callback:(label,index,labels)=>{
                                //          console.log('label :', label);
                                //          console.log('index :', index);
                                //          console.log('labels :', labels);
                                //          return label + ' %'
                                //      },
                                //      min:0,
                                //      max:100
                                //  },
                            }]

                        },
                        tooltips:{
                            callbacks:{
                                
                                // label:(v,c)=>{
                                //     // console.log('v :', v.index);
                                //     // console.log('cccc :', c.datasets)
                                    
                                //     return c.datasets[0].label
                                // },
                                // title:(c)=>{
                                //     // console.log('c :', c);
                                //     return ''
                                // }
                                title:(v,c) =>{
                                    // console.log('v.index :', v[0].index);
                                    // console.log('cTITLE :', c);
 
                                    return c.datasets[0].data[v[0].index].x
                                }
                            }
                            
                       }
                        
                        
                    }}
                
                    />
                }
                    </Grid>
                </Grid>
            )
        })}

        {this.state.facturiAll.length > 0 &&
        <div style={{width:'90%', margin:'20px auto', marginBottom:50}}>
        <h2 className='pm-title'>Toate Facturile Neplatite / Furnizori</h2>
            <Line
                    
              
                    data ={{
                        labels:[''].concat(this.state.dateUniceAll.map(r => r)).concat(['']),
                        datasets:[
                            {
                                label:this.state.facturiAll.map((r)=>{return r.client}),
                                backgroundColor:'transparent',
                                borderColor:'transparent',
                                
                                hoverBackgroundColor:this.state.facturiAll.map((r)=>{return r.color}),
                                pointBackgroundColor:this.state.facturiAll.map((r)=>{return r.color}),
                                pointRadius:15,
                                pointHoverRadius:15,
                                hoverBorderColor:this.state.facturiAll.map((r)=>{return r.color}),
                                data:this.state.facturiAll.map((r)=>{return {x:r.termen, y:r.total}})
                            },
                            
                        ]
            
                    }}
            
                    options={{
                        legend:false,
                        
                        scales:{
                            yAxes:[{
                                afterFit:function(e){
                                    e.width=60
                                },
                                stacked:true,
                                
                                //  ticks:{
                                //      callback:(label,index,labels)=>{
                                //          console.log('label :', label);
                                //          console.log('index :', index);
                                //          console.log('labels :', labels);
                                //          return label + ' %'
                                //      },
                                //      min:0,
                                //      max:100
                                //  },
                            }]
            
                        },
                        tooltips:{
                            callbacks:{
                                
                                label:(v,c)=>{
                                    // console.log('v :', v.index);
                                    // console.log('cccc :', c.datasets)
                                   
                                   return c.datasets[0].label[v.index] + ': '+ c.datasets[0].data[v.index].y + ' lei'
                               },
                               title:(v,c) =>{
                                //    console.log('v.index :', v[0].index);
                                //    console.log('cTITLE :', c);

                                   return c.datasets[0].data[v[0].index].x
                               }
                            }
                            
                       }
                        
                        
                    }}
                
                    />

        </div>
        
        }

        {this.state.facturiAll.length > 0 &&
        <div style={{width:'90%', margin:'20px auto', marginBottom:50}}>
        <h2 className='pm-title'>Toate Facturile Neplatite / Clienti si Furnizori</h2>
            <Line
                    
              
                    data ={{
                        labels:[''].concat(this.state.dateUniceAllFC.map(r => r)).concat(['']),
                        datasets:[
                            {
                                label:this.state.facturiAllFC.map((r)=>{return r.client}),
                                backgroundColor:'transparent',
                                borderColor:'transparent',
                                
                                hoverBackgroundColor:this.state.facturiAllFC.map((r)=>{return r.color}),
                                pointBackgroundColor:this.state.facturiAllFC.map((r)=>{return r.color}),
                                pointRadius:15,
                                pointHoverRadius:15,
                                hoverBorderColor:this.state.facturiAllFC.map((r)=>{return r.color}),
                                data:this.state.facturiAllFC.map((r)=>{return {x:r.termen, y:r.total}})
                            },
                            
                        ]
            
                    }}
            
                    options={{
                        legend:false,
                        
                        scales:{
                            yAxes:[{
                                afterFit:function(e){
                                    e.width=60
                                },
                                stacked:true,
                                
                                //  ticks:{
                                //      callback:(label,index,labels)=>{
                                //          console.log('label :', label);
                                //          console.log('index :', index);
                                //          console.log('labels :', labels);
                                //          return label + ' %'
                                //      },
                                //      min:0,
                                //      max:100
                                //  },
                            }]
            
                        },
                        tooltips:{
                            callbacks:{
                                
                                label:(v,c)=>{
                                    //  console.log('v :', v.index);
                                    //  console.log('cccc :', c.datasets)
                                    
                                     return c.datasets[0].label[v.index] + ': '+ c.datasets[0].data[v.index].y + ' lei'
                                },
                                title:(v,c) =>{
                                    // console.log('v.index :', v[0].index);
                                    // console.log('cTITLE :', c);
 
                                    return c.datasets[0].data[v[0].index].x
                                }
                            }
                            
                       }
                        
                        
                    }}
                
                    />

        </div>
        
        }
    
         </div>
        );
       }
}